<p-panelMenu [model]="itemsMenu" [styleClass]="'kanzi-menu-main'"></p-panelMenu>
